import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, Check } from 'lucide-react';

interface LanguageSwitcherProps {
  isScrolled: boolean;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ isScrolled }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { 
      code: 'en', 
      name: 'English',
      flag: 'https://flagcdn.com/w20/gb.png'
    },
    { 
      code: 'es', 
      name: 'Español',
      flag: 'https://flagcdn.com/w20/es.png'
    },
    { 
      code: 'fr', 
      name: 'Français',
      flag: 'https://flagcdn.com/w20/fr.png'
    },
    { 
      code: 'de', 
      name: 'Deutsch',
      flag: 'https://flagcdn.com/w20/de.png'
    }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (code: string) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-colors ${
          isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
        }`}
      >
        <img 
          src={currentLanguage.flag} 
          alt={currentLanguage.code}
          className="w-5 h-4 object-cover rounded"
        />
        <span>{currentLanguage.name}</span>
        <ChevronDown size={16} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-1 w-40 bg-white rounded-md shadow-lg z-50">
          <div className="py-1">
            {languages.map((language) => (
              <button
                key={language.code}
                onClick={() => changeLanguage(language.code)}
                className={`w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center space-x-2 ${
                  language.code === i18n.language ? 'bg-gray-100' : ''
                }`}
              >
                <img 
                  src={language.flag} 
                  alt={language.code}
                  className="w-5 h-4 object-cover rounded"
                />
                <span>{language.name}</span>
                {language.code === i18n.language && (
                  <Check size={16} className="text-primary-600 ml-auto" />
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;